import React from 'react';
import fr from 'facet-rest';
import {
  TaxDiagnosticLottie,
} from './TaxDiagnosticLottie';

export const TaxDiagnosticLottiePicker = ({ resource }) => {
  return resource.withRelationship(fr.relationships.lottie.name,
    (rel) => (
      <TaxDiagnosticLottie src={rel.link('related').url()} />
    ),
    () => null);
};
